import { Shield, Crown, BadgeCheck, ShieldCheck } from "lucide-react";

const TIERS = {
  New: { cls: "text-zinc-300 border-zinc-400/40", Icon: Shield },
  Trusted: { cls: "text-blue-300 border-blue-400/50", Icon: BadgeCheck },
  Veteran: { cls: "text-emerald-300 border-emerald-400/50", Icon: ShieldCheck },
  Elite: { cls: "text-amber-300 border-amber-400/50", Icon: Crown },
};

export function ReputationBadge({ rep, className = "" }) {
  if (!rep) return null;
  const t = TIERS[rep.tier] || TIERS.New;
  const { Icon } = t;
  const title =
    rep.reliability != null
      ? `${rep.tier} · ${rep.delivered} verified backlink${rep.delivered === 1 ? "" : "s"} delivered · ${rep.reliability}% reliability${rep.missed ? ` · ${rep.missed} missed` : ""}`
      : `${rep.tier} · no verified swaps yet`;
  return (
    <span
      title={title}
      data-testid="reputation-badge"
      className={`inline-flex items-center gap-1 rounded-full border bg-zinc-950/75 backdrop-blur px-2 py-0.5 text-[10px] font-mono font-medium ${t.cls} ${className}`}
    >
      <Icon size={11} className="shrink-0" />
      {rep.tier}
      <span className="opacity-80">· ✓{rep.delivered}</span>
    </span>
  );
}
